import { render } from "./GroupForm.vue?vue&type=template&id=02f7abbe&scoped=true&ts=true"
import script from "./GroupForm.vue?vue&type=script&lang=ts"
export * from "./GroupForm.vue?vue&type=script&lang=ts"

import "./GroupForm.vue?vue&type=style&index=0&id=02f7abbe&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f7abbe"]])

export default __exports__